import React from 'react'
import { Button, Flex, Text } from '@workwhile/ui'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useChargesContextValue } from '../context/ChargesProvider'

export const ChargesPagination = () => {
  const {
    state: { data, pagination, isFetching },
    actions: { setPagination },
  } = useChargesContextValue()

  if (data == null || data.totalPages <= 1) {
    return null
  }

  const page = pagination.pageIndex
  const totalPages = data.totalPages

  return (
    <Flex mt={3} justifyContent="space-between" alignItems="center">
      <Text fontSize={1} color="lightText">
        Page {page + 1} of {totalPages} ({data.totalRows} groups)
        {isFetching ? '…' : ''}
      </Text>
      <Flex gap={2}>
        <Button
          kind="small"
          variant="secondary"
          disabled={page <= 0 || isFetching}
          onClick={() =>
            setPagination((current) => ({
              ...current,
              pageIndex: Math.max(0, current.pageIndex - 1),
            }))
          }
        >
          <ChevronLeft size={14} />
        </Button>
        <Button
          kind="small"
          variant="secondary"
          disabled={page + 1 >= totalPages || isFetching}
          onClick={() =>
            setPagination((current) => ({
              ...current,
              pageIndex: current.pageIndex + 1,
            }))
          }
        >
          <ChevronRight size={14} />
        </Button>
      </Flex>
    </Flex>
  )
}
